package org.moxultimate.topwithmox.shows.di

import io.ktor.client.*
import io.ktor.client.engine.js.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json
import org.koin.dsl.module
import org.moxultimate.topwithmox.shows.api.ShowsRepository
import org.moxultimate.topwithmox.shows.ui.ShowsViewModel

val showsModule = module {

    // Shared HttpClient — singleton so the underlying JS engine is reused
    single {
        HttpClient(Js) {
            install(ContentNegotiation) {
                json(Json {
                    ignoreUnknownKeys = true
                    isLenient = true
                })
            }
        }
    }

    // Repository — singleton; holds no mutable state so it is safe to share
    single {
        ShowsRepository(httpClient = get())
    }

    // ViewModel — factory so each composable gets a fresh instance with its own scope
    factory {
        ShowsViewModel(repository = get())
    }
}
